import { render, staticRenderFns } from "./AscBarChartWrapper.vue?vue&type=template&id=a85a05f4&"
import script from "./AscBarChartWrapper.vue?vue&type=script&lang=js&"
export * from "./AscBarChartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports